import OneDriveSettingsTab from './one-drive-settings';

export default OneDriveSettingsTab;
